<template>
  <div class="full-control">
    <div class="list">
      <div v-if="loaded && EventObject.length > 0">
        <ul class="tab_info_list">
          <li
            v-for="(item, index) in EventObject"
            :key="buildId(item, index)"
            :id="buildId(item, index)"
            :class="{ selected: selectedIndex === index }"
            style="cursor: pointer;"
            @click="onClick(item, index)"
          >
            <md-icon
              v-show="item?.kommentar && item.kommentar !== '<p></p>'"
              class="anfrageIcon tick-icon"
            >
              check
            </md-icon>
            <span class="fweight600">{{ item.pureName || item.name }}</span><br/>
            <p class="p_desc">{{ item.date || item.desc }}</p>
            <span class="vendor">{{ item.vendor }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  name: "EventComments",
  props: {
    EventObject: {
      type: Array,
      required: true
    },
    loaded: {
      type: Boolean,
      required: false,
      default: false
    },
    // index that should be visually selected (controlled by parent)
    selectedIndexProp: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedIndex: null
    }
  },
  watch: {
    // keep local selectedIndex in sync with parent when it changes
    selectedIndexProp(newVal) {
      if (typeof newVal === 'number') {
        this.selectedIndex = newVal;
      }
    }
  },
  mounted() {
    // initialize from prop on mount
    if (typeof this.selectedIndexProp === 'number') {
      this.selectedIndex = this.selectedIndexProp;
    }
  },
  methods: {
    onClick(item, index) {
      this.selectedIndex = index;
      // keep existing emit behavior
      const compID = index + (item.compID || '');
      this.checkSaveKommentar(item, compID);
    },
    checkSaveKommentar(item, compID) {
      this.$emit('check-save-kommentar', item, compID);
    },
    buildId(item, index) {
      const base =
          item?.compID ??
          item?.id ??
          `auto-${index}`; // fallback if neither compID nor id exist
      return `dattl-${base}`;
    }
  },
}
</script>
<style scoped lang="scss">
.anfrageIcon.tick-icon {
  font-size: 16px;
  color: #4caf50;
  margin-right: 5px !important; // adjust distance as needed
  vertical-align: middle;
}
</style>